import './phone-info.ajscss';

import { IPositionDeprecatedService } from '@agent/core/agent/position-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IUnitOutgoingCallDeprecatedService } from '@agent/core/phone/outcall/unit-outgoing-call-deprecated.service';
import { IContact } from '@commons/models/contact';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';
import { i18n } from 'i18next';
import moment from 'moment';

import { Booking, BookingFacade, isNotNullOrUndefined } from '@contact/upgrade';

import templateUrl from './phone-info.template.html';

const MODULE_NAME = 'contactPhoneInfo';

class PhoneInfoCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;
  contactNumber: string;
  contactNumberTries: number;
  dialedNumber: string;
  waitedTime: string;
  isCampaignCall: boolean = false;
  isIncomingCall: boolean = false;
  showWaitedTime: boolean = false;
  isNoNumberSpontaneousOutcall: boolean = false;
  connectionId: string;

  constructor(
    private readonly $i18next: i18n,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly bookingFacade: BookingFacade,
    private readonly unitOutgoingCallDeprecatedService: IUnitOutgoingCallDeprecatedService,
    private readonly positionDeprecatedService: IPositionDeprecatedService
  ) {}

  $onInit(): void {
    this.bookingFacade
      .getById(this.responseId)
      .pipe(isNotNullOrUndefined(), ng1Destroy(this))
      .subscribe(contact => this.initialize(contact));

    this.contactDeprecatedService
      .contactUpdated$()
      .pipe(ng1Destroy(this))
      .subscribe(contact => this.initialize(contact));
  }

  private initialize(contact: Booking): void {
    let isOutgoingCall = this.unitOutgoingCallDeprecatedService.isUnitOutgoingCallContact(contact);
    this.showWaitedTime = !isOutgoingCall && !contact.campaign;
    this.connectionId = contact.connectionId;
    if (isOutgoingCall) {
      if (this.positionDeprecatedService.hasPosition()) {
        this.contactNumber = this.positionDeprecatedService.position!.uri;
      }
      this.dialedNumber = contact.phoneNumber;
      this.isNoNumberSpontaneousOutcall = this.dialedNumber === 'SPONTANEOUS_OUTCALL';
    } else if (contact.campaign) {
      this.isCampaignCall = true;
      // add current call in tries nb
      this.contactNumberTries = (contact.campaign?.nbTries || 0) + 1;
      this.contactNumber = contact.campaign?.campaign.name;
      this.dialedNumber = contact.phoneNumber;
    } else {
      this.isIncomingCall = true;
      this.contactNumber = contact.phoneNumber;
      this.dialedNumber = contact.dialedNumber;
    }

    if (this.showWaitedTime) {
      this.waitedTime = this.buildWaitedTime(contact);
    }
  }

  private buildWaitedTime(contact: IContact): string {
    let waitedMoment = moment.unix(Math.round(contact.waitedTime / 1000)).utc();
    return this.$i18next.t('agent:contact.info.waited_time', {
      minutes: waitedMoment.minutes(),
      seconds: waitedMoment.seconds(),
    });
  }
}

export class PhoneInfo implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = [
    '$i18next',
    'contactDeprecatedService',
    'contactFacade',
    'unitOutgoingCallDeprecatedService',
    'positionDeprecatedService',
    PhoneInfoCtrl,
  ];
}

export default MODULE_NAME;
